import BaseApi from '../base/base'
import Message from '../../models/live_chat_message'
import Participant from '../../models/live_chat_participant'
import MessageForm from '../../forms/live_chat_message'

export default class LiveChatMessageApi extends BaseApi {
  constructor() {
    super()
    this.path = '/live_chat_messages'
  }
  async index(params: {targetableId: string, targetableType: string}) {
    this.path = '/live_chat_messages'
    const response = await this.getRequest(params)
    return {
      messages: response.data.map(element => new Message(element)),
      participantsCount: response.meta.participantsCount
    }
  }

  async create(params: MessageForm) {
    this.path = '/live_chat_messages'
    const response = await this.postRequest(params)
    return new Message(response.data)
  }

  async participants(params: {targetableId: string, targetableType: string}) {
    this.path = '/live_chat_messages/participants'
    const response = await this.getRequest(params)
    return response.data.map(element => new Participant(element))
  }
}
